import { redirect } from '@hub/router/domain-routes';
import type { AuthenticatedGuard } from '@hub/router/pages/_authenticated.guard';
import { authUser } from '@hub/router/routerAuth';
import { HomePaths } from '../home/route.paths';
import { hasDunningLock } from './dunning';
import { BillingPaths } from './route.paths';

const ALLOWED_PATHS: Set<string> = new Set([BillingPaths.payment.path, BillingPaths.paymentEdit.path, HomePaths.home.path]);

/**
 * Confines dunning-locked (dl2) users to home + the payment read/edit views so they
 * can fix their payment; every other authenticated route redirects to payment. The
 * edit path must be allowed, else a locked user can never actually update payment.
 */
export const dunningRecoveryGuard: AuthenticatedGuard = ({ context, location }) => {
  if (hasDunningLock(authUser(context.auth)?.flags) && !ALLOWED_PATHS.has(location.pathname)) {
    throw redirect({ to: BillingPaths.payment.path, replace: true });
  }
};
